module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-toolbar"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left"
  }, [(_vm.image) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  }) : (_vm.moduleIdentifier) ? _c('module-logo', {
    staticClass: "logo",
    attrs: {
      "identifier": _vm.moduleIdentifier
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("header-icon"), _vm._v(" "), _vm._t("header-left"), _vm._v(" "), _c('h1', {
    staticClass: "c-toolbar__title title"
  }, [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('div', {
    staticClass: "l-level__right"
  }, [_c('div', {
    staticClass: "l-level__item"
  }, [_vm._t("header-right")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4d0336","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/PageTitle.vue
// module id = 3070
// module chunks = 0